import NodeEnvironment from '../Constants/NodeEnvironment';

class Logger {
    public enable = process.env.NODE_ENV === NodeEnvironment.DEVELOPMENT;

    public log: (...args: any[]) => void = this.out.bind(this, 'log');

    public error: (...args: any[]) => void = this.out.bind(this, 'error');

    private out(reporterMethod: string, ...args: any[]): void {
        if (this.enable) console[reporterMethod](...args);
    }
}

const logger = new Logger();

(window as any)._logger = logger;

export {
    logger as default,
    Logger
};